import * as React from "react";
import { IReport6Presenter } from "../../../presenter/report/Report6Presenter";
import Report6ParamsBox from "../../components/report/Report6ParamsBox";
import { Typography, Icon, Divider } from "antd";
import Report6Preview from "../../components/report/Report6Preview";
import Report6PDFExportLink from "../../components/report/Report6PDFExportLink";

export interface Props {}

export interface State extends IReport6Presenter {}

export default class Report6Page extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      report6SelectedApplicantIds,
      report6SelectedReportingPeriod,
      onApplicantsChange,
      onChangeReportingPeriod,
      translate,
      report6Applicants,
      report6ReportingPeriodList,
      report6ReportApplicants,
      getReport6PDF,
      getReport6XLSXLink,
      onApplicantSearch
    } = this.state;

    const { report6Loader } = this.state.loaders;
    return (
      <div className={"report-container"}>
        <Report6ParamsBox
          translate={translate}
          applicants={report6Applicants}
          onApplicantsChange={onApplicantsChange}
          selectedApplicantIds={report6SelectedApplicantIds}
          selectedReportingPeriod={report6SelectedReportingPeriod}
          onChangeReportingPeriod={onChangeReportingPeriod}
          reportingPeriodList={report6ReportingPeriodList}
          getPDFReport={getReport6PDF}
          loading={report6Loader}
          onApplicantSearch={onApplicantSearch}
        />
        <Divider type={"vertical"} style={{ height: "100%" }} />
        <div style={{ overflow: "hidden", width: "75%" }}>
          {report6ReportApplicants && (
            <div style={{ paddingLeft: 10 }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between"
                }}
              >
                <Typography.Title style={{ fontSize: 14 }}>
                  {translate("reports.review_report")}
                </Typography.Title>
                <div>
                  {!this.state.loaders.report6Loader && (
                    <Report6PDFExportLink
                      translate={translate}
                      applicants={report6ReportApplicants}
                      title={translate("report6.preview_title")}
                      fileName={`${translate("report6.pdf_filename")}.pdf`}
                    />
                  )}
                  <Divider
                    type={"vertical"}
                    style={{ fontSize: 10, height: "100%" }}
                  />
                  <a
                    key="file-excel"
                    href={getReport6XLSXLink()}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon
                      type="file-excel"
                      theme={"outlined"}
                      style={{ fontSize: 20, color: "#20744B" }}
                    />
                  </a>
                </div>
              </div>
              <Divider type={"horizontal"} />
              <Report6Preview
                translate={translate}
                applicants={report6ReportApplicants || []}
                title={translate("report6.preview_title")}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
